import React, {useRef} from 'react';
import {motion, useInView} from 'framer-motion';

import ComparisonCard from './ComparisonCard';
import TechBox from './TechBox';
import TechIntroductionCard from './TechIntroductionCard';

import {useMediaQuery} from '../../hooks/useMediaQuery';
import styles from './styles/main-08.module.css';

import {ReactComponent as ProcessComparisonImg} from '../../assets/main08/process-comparison.svg';
import {ReactComponent as SpeedComparisonImg} from '../../assets/main08/speed-comparison.svg';

const easeInMotion = {
    ease: 'easeIn',
    duration: 0.8
};

const DivWithRef = ({ className = styles.boxCard, amount, children, isFirst }) => {
    const ref = useRef(null);

    const isInView = useInView(ref, {
        once: true,
        amount: amount
    });

    const cardMotion = {
        hidden: { opacity: 0, y: 100 },
        visible: { 
          opacity: 1,
          y: 0,
          transition: {
            type: 'spring',
            stiffness: 300,
            damping: 20,
            delay: isFirst ? 0.8 : 0
          }
        }
    };

    return (
        <motion.div
            ref={ref}
            className={className}
            initial={cardMotion.hidden}
            animate={isInView ? cardMotion.visible : cardMotion.hidden}
            transition={cardMotion.transition}
        >
            {children}
        </motion.div>
    );
};

export default function Main08() {
    const mobile = useMediaQuery('(max-width: 768px)');
    const mobileMedium = useMediaQuery('(min-width: 481px) and (max-width: 768px)');
    const mobileLarge = useMediaQuery('(min-width: 769px) and (max-width: 1024px)');

    const ref = useRef(null);

    const isInView = useInView(ref, {
        once: true,
        amount: mobile ? 0.1 : 0.2,
        margin: mobileMedium ? '-10px 0px' : '-100px 0px'
    });

  return (
    <div className={styles.wrapper}>
        <div className={styles.container} ref={ref}>
            <motion.div
                className={styles.boxTitle}
                initial={{ opacity: 0 }}
                animate={isInView ? { opacity: 1 } : { opacity: 0 }}
                transition={easeInMotion}
            >
                {(mobile || mobileMedium || mobileLarge)
                    ? <p>AI가 만든 <span>SQL</span>,<br />정말 믿을 수 있을까요?</p>
                    : <p>AI가 만든 <span>SQL</span>, 정말 믿을 수 있을까요?</p>
                }
                <p>
                    "일반적인 AI의 SQL 생성 정확도는 80% 수준입니다.<br/>
                    하지만 기업 데이터를 다룰 때는 99%도 부족합니다."                
                </p>
            </motion.div>
            <DivWithRef amount={mobile ? 0.1 : 0.2} isFirst >
                <TechIntroductionCard />
            </DivWithRef>
            <DivWithRef amount={mobile ? 0.1 : 0.2}>
                <ComparisonCard
                    title='SQL 생성 속도'
                    Image={SpeedComparisonImg}
                />
                <ComparisonCard
                    title='대규모 처리 능력(30개 요청 처리)'
                    Image={ProcessComparisonImg}
                />
            </DivWithRef>
            <DivWithRef className={styles.boxTech} amount={mobile ? 0.2 : 0.3}>
                <p>핵심 기술</p>
                <div className={styles.techList}>
                    <TechBox 
                        tech='특허 등록'
                        title='DB 구조 이해 시스템'
                        content='실시간 메타데이터 분석 및 테이블 관계 자동 매핑'
                    />
                    <TechBox 
                        tech='특허 출원'
                        title='SQL 오류 방지 시스템'
                        content='실시간 문법 검증 및 자동 최적화'
                    />
                </div>
            </DivWithRef>
        </div>
    </div>
  );
}
